import React, { useState, useCallback } from 'react';

import { KeyboardArrowDown, KeyboardArrowUp, Close } from '@mui/icons-material';

import iconDotGov from './icon-dot-gov.svg';
import iconHttps from './icon-https.svg';
import {
  Banner,
  BannerHeader,
  BannerHeaderInner,
  BannerHeaderIcon,
  BannerHeaderContent,
  BannerHeaderHiddenContent,
  BannerHeaderButton,
  BannerHeaderContentText,
  BannerContent,
  BannerContentCol,
  ExitButton,
} from './styledComponents';
import iconFlag from './us_flag_small.png';

export const SiteBanner: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = useCallback(() => {
    setExpanded(!expanded);
  }, [setExpanded, expanded]);

  return (
    <Banner>
      <BannerHeader>
        <BannerHeaderInner>
          <BannerHeaderIcon>
            <img src={iconFlag} alt='U.S. flag' />
          </BannerHeaderIcon>
          <BannerHeaderContent>
            <BannerHeaderContentText>
              An official website of the United States government
            </BannerHeaderContentText>
            <BannerHeaderHiddenContent aria-hidden='true'>
              Here’s how you know
              {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </BannerHeaderHiddenContent>
            <BannerHeaderButton
              onClick={toggleExpanded}
              className='usa-accordion__button usa-banner__button'
              aria-expanded={expanded}
              aria-controls='gov-banner'
            >
              <span>
                Here's how you know
                {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </span>
            </BannerHeaderButton>
          </BannerHeaderContent>

          <ExitButton visible={expanded}>
            <Close />
          </ExitButton>
        </BannerHeaderInner>
      </BannerHeader>
      {expanded && (
        <BannerContent>
          <BannerContentCol>
            <img src={iconDotGov} alt='Dot gov' />
            <div className='usa-media-block__body'>
              <p>
                <strong>The .mil means it's official.</strong>
                <br />
                Federal government websites often end in .gov or .mil. Before
                sharing sensitive information, make sure you’re on a federal
                government site.
              </p>
            </div>
          </BannerContentCol>
          <BannerContentCol>
            <img src={iconHttps} alt='This site uses HTTPS' />
            <div>
              <p>
                <strong>The site is secure.</strong>
                <br />
                The <strong>https://</strong> ensures that you are connecting to
                the official website and that any information you provide is
                encrypted and transmitted securely.
              </p>
            </div>
          </BannerContentCol>
        </BannerContent>
      )}
    </Banner>
  );
};
